export function formatPostcodeSuggestionText(prediction: google.maps.places.PlacePrediction): string {
	const full = parsePredictionText(prediction);

	const postcode = parsePostcode(full);
	if (!postcode) {
		return full;
	}

	// Remove the postcode from the original string and clean up separators
	const without = full
		.replace(new RegExp(`\\b${postcode}\\b`), '')
		.replace(/\s+,/g, ',')
		.replace(/,\s+,/g, ',')
		.replace(/\s{2,}/g, ' ')
		.replace(/^,\s*|\s*,\s*$/g, '')
		.trim();

	return `${postcode} ${without}`;
}

export function formatPostcodeSuggestionNumber(prediction: google.maps.places.PlacePrediction): string {
	return parsePostcode(parsePredictionText(prediction)) ?? '';
}

const parsePostcode = (text: string): string | null => {
	const postcodeMatch = text.match(/\b(\d{4,6})\b/);

	if (!postcodeMatch) {
		return null;
	}

	return postcodeMatch[1];
};

const parsePredictionText = (prediction: google.maps.places.PlacePrediction): string => {
	return prediction.text?.text ?? [prediction.mainText?.text, prediction.secondaryText?.text].filter(Boolean).join(', ') ?? '';
};
